import { CSS_VAR_PREFIX } from "@/constants";
import { ThemeConfig } from "@chakra-ui/react";


export const config: ThemeConfig = {
  useSystemColorMode: true,
  initialColorMode: "light",
  cssVarPrefix: CSS_VAR_PREFIX,
}